/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnplan2Inputs */

const en_partnerscolumnplan2 = /** @type {(inputs: Partnerscolumnplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const de_partnerscolumnplan2 = /** @type {(inputs: Partnerscolumnplan2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Partnerscolumnplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnplan2 = /** @type {((inputs?: Partnerscolumnplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnplan2(inputs)
	return de_partnerscolumnplan2(inputs)
});
export { partnerscolumnplan2 as "partnersColumnPlan" }